import { useNavigate } from "react-router-dom";
import { CONTENT } from "@/content";
import { Nav } from "@/components/ui/Nav";
import { Footer } from "@/components/ui/Footer";

const updatedAt = "10 de junho de 2026";

export default function Privacy() {
  const navigate = useNavigate();
  const goFunnel = () => navigate("/agendar/contato");
  const goHome = () => navigate("/");

  return (
    <>
      <Nav onCTA={goFunnel} onHome={goHome} />
      <main className="privacy-page page-enter">
        <section className="privacy-hero">
          <div className="wrap privacy-wrap">
            <p className="eyebrow">Privacidade e dados</p>
            <h1>Política de Privacidade</h1>
            <p className="lead">
              Este documento explica, de forma clara, como a UdiSchool usa os dados enviados no site,
              no funil de Avaliação Diagnóstica e nos contatos relacionados aos serviços.
            </p>
            <span className="privacy-updated">Última atualização: {updatedAt}</span>
          </div>
        </section>

        <section className="privacy-body section">
          <div className="wrap privacy-wrap">
            <article className="privacy-card">
              <h2>1. Quem trata seus dados</h2>
              <p>
                A UdiSchool usa os dados informados por você para organizar a Avaliação Diagnóstica,
                manter contato sobre sua solicitação e apresentar caminhos de aprendizagem relacionados
                aos programas da escola.
              </p>

              <h2>2. Quais dados coletamos</h2>
              <p>Podemos coletar dados que você envia voluntariamente pelo site, como:</p>
              <ul>
                <li>nome, e-mail e WhatsApp;</li>
                <li>respostas sobre sua história com o inglês, objetivos e dificuldades;</li>
                <li>data e horário escolhidos para a Avaliação Diagnóstica;</li>
                <li>informações técnicas básicas, como navegador, data do acesso e identificador de IP protegido por hash.</li>
              </ul>

              <h2>3. Para que usamos os dados</h2>
              <p>Os dados são usados para:</p>
              <ul>
                <li>confirmar e organizar sua Avaliação Diagnóstica;</li>
                <li>entrar em contato por e-mail ou WhatsApp;</li>
                <li>entender seu perfil de aprendizagem e seus objetivos;</li>
                <li>melhorar a segurança do site e reduzir abuso de formulários;</li>
                <li>registrar histórico de atendimento no painel interno da UdiSchool.</li>
              </ul>

              <h2>4. Compartilhamento</h2>
              <p>
                A UdiSchool não vende seus dados. O acesso fica restrito à equipe responsável pelo
                atendimento e pela gestão da Avaliação Diagnóstica. Dados podem ser processados por
                serviços técnicos necessários para hospedagem, banco de dados, segurança, e envio de
                mensagens, sempre dentro da finalidade informada.
              </p>

              <h2>5. Armazenamento e segurança</h2>
              <p>
                Usamos medidas técnicas para proteger os dados, incluindo conexão HTTPS, acesso
                administrativo com senha, tokens de autenticação e separação entre site público,
                API e banco de dados. O endereço IP não é guardado em texto puro; ele é transformado
                em um hash para reduzir exposição de dados pessoais.
              </p>

              <h2>6. Seus direitos</h2>
              <p>
                Você pode solicitar confirmação de tratamento, acesso, correção, atualização ou
                exclusão dos seus dados, conforme regras aplicáveis da Lei Geral de Proteção de Dados
                Pessoais (LGPD).
              </p>

              <h2>7. Como solicitar atendimento sobre dados</h2>
              <p>
                Para falar sobre seus dados pessoais, entre em contato pelo WhatsApp da UdiSchool:
                <a href={CONTENT.brand.whatsappUrl} target="_blank" rel="noopener">
                  {" "}
                  {CONTENT.brand.whatsapp}
                </a>
                .
              </p>

              <h2>8. Atualizações desta política</h2>
              <p>
                Esta política pode ser atualizada para refletir mudanças no site, nos serviços ou em
                obrigações legais. A versão mais recente ficará sempre disponível nesta página.
              </p>
            </article>
          </div>
        </section>
      </main>
      <Footer onCTA={goFunnel} onHome={goHome} />
    </>
  );
}
